import React, { useMemo } from 'react';

import { DescriptionList, DescriptionItem, Select } from '@gogame/components';

import Status from '../Status';

const Metadata = ({ data, currentVersion, versions, onChangeVersion }) => {
  const options = useMemo(() => {
    return versions?.map((_, i) => ({ id: i, name: `V${i + 1}` })) || [];
  }, [versions]);
  return (
    <DescriptionList variant={'column'} data={data} disableGutters={true}>
      {options.length > 1 ? (
        <DescriptionItem
          label={'Version'}
          value={currentVersion}
          type={({ value }) => (
            <Select
              value={value}
              options={options}
              onChange={(_, v) => onChangeVersion(v)}
              width={120}
            />
          )}
        />
      ) : null}

      <DescriptionItem
        label={'Status'}
        type={({ value }) => (
          <Status id={value?.status} isSapSynced={value?.isSapSynced} />
        )}
        isSapSynced={data.isSapSynced}
        value={data}
      />
      <DescriptionItem label={'Owner'} field={'owner'} />
      <DescriptionItem
        label={'NDA uploaded by'}
        type={'metadata'}
        field={'nda'}
        userField={'uploadedBy.name'}
        dateField={'uploadedDate'}
      />
      <DescriptionItem
        label={'Last updated by'}
        type={'metadata'}
        field={'metadata'}
        userField={'lastUpdatedBy'}
        dateField={'lastUpdatedDate'}
      />
      <DescriptionItem
        label={'Created by'}
        type={'metadata'}
        field={'metadata'}
        userField={'createdBy'}
        dateField={'createdDate'}
      />
    </DescriptionList>
  );
};

export default Metadata;
